import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { RxCross1 } from 'react-icons/rx';
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaSpinner } from 'react-icons/fa';
import SummerNote from '../../TaskCreator/CreatorTask/SummerNote';
import { useDispatch } from 'react-redux';
import { addAdminPlanAction } from '../../../Redux/Actions/AdminUserActivity';

const PlanModel = (props) => {
    const dispatch = useDispatch()
    const [planData, setPlanData] = useState({
        "name": "",
        "price": "",
        "credit": "",
        "description": ""
    })
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPlanData({ ...planData, [name]: value })
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        props.setLoader({
            ...props.loader,
            update: true
        })
        let url = "add-package"
        if (props.curElem.id) {
            url = "update-package"
        }
        dispatch(addAdminPlanAction(url, planData, props.loader, props.setLoader, props.fetchData, props.handleClose))

    }
    useEffect(() => {
        if (props.curElem.id) {
            setPlanData(props.curElem)
        }
    }, [props.curElem.id])
    return (
        <Modal className="theme-modal table" show={props.show} onHide={props.handleClose} backdrop="static" centered>

            <Modal.Header closeButton style={{ borderBottom: "0", position: "absolute", top: "23px", right: "25px", zIndex: "20" }}>
            </Modal.Header>
            <Modal.Body className='mt-4 pt-4'>
                <h5 className='text-center mb-3'>Add Plan</h5>
                <div className='creator_new_task h-100'>
                    <form onSubmit={handleSubmit}>
                        <div className='account-block phone-emails mb-2'>
                            <div className='submission_wrap submission_bg mt-3 mb-3'>
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control border-0" placeholder="Enter Name" name="name" value={planData.name} onChange={handleChange} />
                            </div>
                            <div className='submission_wrap submission_bg mt-3 mb-3'>
                                <label className="form-label">Price</label>
                                <input type="number"
                                    className="form-control border-0"
                                    placeholder="Enter Price" name="price"
                                    value={planData.price} onChange={handleChange}
                                    onKeyDown={(e) => {
                                        if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            <div className='submission_wrap submission_bg mt-3 mb-3'>
                                <label className="form-label">Credits</label>
                                <input type="number" className="form-control border-0" placeholder="Enter Credits"
                                    name="credit"
                                    value={planData.credit} onChange={handleChange}
                                    onKeyDown={(e) => {
                                        if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                            <div className='submission_wrap theme-focus-bg submission_bg my-3 pt-3'>
                                <label className="form-label">Description</label>
                                <SummerNote state={planData} setState={setPlanData} editing={true} />
                                {/* <textarea type="text" placeholder='Description' className='form-control border-0 mb-4'
                                    name="descraption"
                                    value={planData.descraption} onChange={handleChange}
                                ></textarea> */}
                            </div>
                            <div className='d-flex justify-content-end gap-2 mt-4'>
                                <button className='theme-btn' type="button" onClick={props.handleClose}>Cancel</button>
                                <button className='theme-btn' type="submit">{props.curElem.id ? "Update" : "Add plan"}{props.loader.update ? <FaSpinner className='spin ms-1' style={{ fontSize: "13px" }} /> : ""}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal >

    )
}

export default PlanModel